import {computed, inject, Injectable, signal} from '@angular/core';
import {NotificationsStore} from './notification.store';

export type NotificationFilterType = 'READED' | 'UNREADED' | 'ALL'

@Injectable({
	providedIn: 'root'
})
export class NotificationsContext {
	private readonly store = inject(NotificationsStore)

	readonly allNotifications = this.store.notifications;
	readonly loading = this.store.loading;
	readonly error = this.store.error;

	readonly notificationFilter= signal<NotificationFilterType>('ALL');

	readonly notifications = computed(() =>
		this.allNotifications().filter(
			n => {
				if (this.notificationFilter() === 'ALL') return true;
				if (this.notificationFilter() === 'UNREADED') return !n.read;
				return n.read;
			}
		)
	)

}
